import FormSection from "./FormSection";
import React, { forwardRef, useImperativeHandle, useRef } from "react";

/*

 At mount/update react pass the imperative API object to 'handle'
 At unmount react will pass null to 'handle'
    const setSectionRef = (sectionId) => (handle) => {
      if (!handle) {
        delete sectionRefs.current[sectionId];
        return;
      }
      sectionRefs.current[sectionId] = handle;
    }

*/

const FormTab = forwardRef(({ active, tab }, ref) => {
  const sectionRefs = useRef({});

  const setSectionRef = (sectionId) => (handle) => {
    if (!handle) {
      delete sectionRefs.current[sectionId];
      return;
    }
    sectionRefs.current[sectionId] = handle;
  };

  useImperativeHandle(
    ref,
    () => ({
      getKey: () => tab.sctName,
      getState: () => {
        const result = {};
        for (const section of tab.sections) {
          const sid = String(section.scsName);
          result[sid] = sectionRefs.current[sid]?.getState() ?? null;
        }
        return result;
      },
      getFlatState: () => {
        let result = {};
        for (const section of tab.sections) {
          const sid = String(section.scsName);
          const sectionState = sectionRefs.current[sid]?.getState() ?? {};
          result = { ...result, ...sectionState };
        }
        // console.log(result);
        return result;
      },
      reset: () => {
        for (const section of tab.sections) {
          const sid = String(section.scsName);
          sectionRefs.current[sid]?.reset();
        }
      },
    }),
    [tab?.sctName, tab?.sections],
  );

  return (
    <div
      className="ui bottom attached active tab segment"
      style={{ display: active ? "block" : "none" }}
    >
      {tab.sections.map((section, i) => (
        <FormSection
          ref={setSectionRef(String(section.scsName))}
          tab={tab.sctId}
          section={section}
          key={section.scsName}
        />
      ))}
    </div>
  );
});

export default FormTab;
